import clsx from 'clsx'

import type { SizeType } from '@wartek-id/button-v1'
import { Button } from '@wartek-id/button-v1'

interface FilterButtonsProps<T> {
  activeValue?: T
  items: {
    label: string
    value: T
  }[]
  onChange?: (value: T) => any
  btnSize?: SizeType
}

const FilterButtons = <T,>({
  activeValue,
  items,
  btnSize = 'md',
  onChange = () => {},
}: FilterButtonsProps<T>) => {
  return (
    <div className="flex gap-4" role="listbox">
      {items.map(({ label, value }) => (
        <Button
          key={`filter-button-${value}`}
          className={clsx(
            '!rounded-full',
            JSON.stringify(activeValue) === JSON.stringify(value) &&
              '!text-blue-70  !outline-blue-70 !bg-[#F2F8FE]'
          )}
          role="option"
          size={btnSize}
          aria-selected={JSON.stringify(activeValue) === JSON.stringify(value)}
          color="white"
          onClick={() => onChange(value)}
        >
          {label}
        </Button>
      ))}
    </div>
  )
}

export default FilterButtons
